import React, {useState} from 'react';
import PropTypes from 'prop-types';
// utils
import {formatPrice} from '~/utils/quote';
import Spinner from '~/components/SimpleSpinner';
import {Typography} from '@customink/pigment-react';
import {useSelector} from 'react-redux';
import {isAnchorSingleSize} from '~/selectors/ProductSelectors';

import './CartItem.scss';

const renderSizes = quoteQuantities => {
  const sizes = Object.keys(quoteQuantities)
    .filter(size => quoteQuantities[size] > 0)
    .map(size => `${quoteQuantities[size]} ${size}`);
  return sizes.map(size => (
    <span className="cartItem-Details-sizeQuantities-item" key={size}>
      {size}
    </span>
  ));
};

const renderSizeQuantities = (
  onChangeQuantities,
  quoteQuantities,
  showEdit = true
) => {
  const isProductSingleSize = useSelector(isAnchorSingleSize);

  return (
    <Typography
      variant="uiTextTiny"
      className="cartItem-Details-sizeQuantities">
      {!isProductSingleSize && renderSizes(quoteQuantities)}
      {showEdit && (
        <a
          className="CartItem-Details-sizeQuantities-edit"
          onClick={onChangeQuantities}>
          Edit
        </a>
      )}
    </Typography>
  );
};

const renderPrice = subTotal => {
  return (
    <Typography variant="heading5" className="cartItem-Price">
      {formatPrice(subTotal)}
    </Typography>
  );
};

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const CartItem = props => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const {
    allowEditSizeQuantities,
    subTotal,
    quoteQuantities,
    onChangeQuantities
  } = props;

  const onLoadHandler = () => {
    setImageLoaded(true);
  };

  const renderCartItem = () => {
    return (
      <div className="cartItem">
        <div className="cartItem-Image">
          {!imageLoaded && <Spinner size={30} />}
          <img src={props.imageSrc} onLoad={onLoadHandler} />
        </div>
        <div className="cartItem-Details">
          <Typography variant="heading5" className="cartItem-Details-styleName">
            {props.styleName}
          </Typography>
          <Typography
            variant="uiTextSmall"
            className="cartItem-Details-colorName-qty-group">
            <span className="cartItem-Details-colorName">
              {props.colorName}
            </span>
            <span className="cartItem-Details-divider">|</span>
            <span className="cartItem-Details-qty">Qty {props.quantity}</span>
          </Typography>
          {props.showSizeQuantities
            ? renderSizeQuantities(
                onChangeQuantities,
                quoteQuantities,
                allowEditSizeQuantities
              )
            : ''}
          {props.shouldRenderNewLinePrice ? renderPrice(subTotal) : ''}
        </div>
        {!props.shouldRenderNewLinePrice ? renderPrice(subTotal) : ''}
      </div>
    );
  };

  return renderCartItem();
};

const propTypes = {
  allowEditSizeQuantities: PropTypes.bool,
  borderAroundStyles: PropTypes.bool,
  colorName: PropTypes.string,
  imageSrc: PropTypes.string,
  quantity: PropTypes.number,
  quoteQuantities: PropTypes.object,
  shouldRenderNewLinePrice: PropTypes.bool,
  showDividerBetweenStyles: PropTypes.bool,
  showSizeQuantities: PropTypes.bool,
  styleName: PropTypes.string,
  subTotal: PropTypes.number,
  onChangeQuantities: PropTypes.func
};

CartItem.propTypes = propTypes;

CartItem.defaultProps = {
  allowEditSizeQuantities: true,
  borderAroundStyles: false,
  showSizeQuantities: false,
  showDividerBetweenStyles: false,
  shouldRenderNewLinePrice: false,
  quoteQuantities: {},
  onChangeQuantities: () => {}
};

export default CartItem;
